import { render, staticRenderFns } from "./ModalExpenses.vue?vue&type=template&id=6b65dba2&scoped=true&lang=pug"
import script from "./ModalExpenses.vue?vue&type=script&lang=js"
export * from "./ModalExpenses.vue?vue&type=script&lang=js"
import style0 from "./ModalExpenses.vue?vue&type=style&index=0&id=6b65dba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b65dba2",
  null
  
)

export default component.exports